import styles from "~/index.css";
import "~/util/FocusManager";

import * as React from "react";
import * as ReactDOM from "react-dom";

import Root from "~/containers/Root";

import client from "~/graphql/client";
import { theme } from "~/styled/theme";
import { shopConfig } from "./helpers/shopConfig";

function render() {
  styles.use();
  ReactDOM.render(
    <Root client={client} theme={theme} />,
    document.getElementById("sf-contact-form") as HTMLElement
  );
}

(window as any).__sc = {
  render,
  unmount: () => {
    styles.unuse();
    const sfRoot = document.getElementById("sf-contact-form");
    if (sfRoot) {
      ReactDOM.unmountComponentAtNode(sfRoot as HTMLElement);
    }
  }
};

if (shopConfig.autoRender) {
  render();
}



// WEBPACK FOOTER //
// ./src/index.tsx